import e from "../../utils/classNames.js";
import { PLACEMENT as t } from "../../values/Placement.js";
import n from "../tooltip/SimpleTooltip.js";
import r from "../icon/Icon.js";
import { jsx as i } from "react/jsx-runtime";
//#region src/components/pills/PillsItem.tsx
var a = (a) => {
	let { active: o = !1, disabled: s = !1, iconName: c, tooltip: l, tooltipPlacement: u = t.BOTTOM, className: d, children: f, "aria-label": p, title: m, ...h } = a, g = l != null && l !== !1, _ = p ?? (c && typeof l == "string" ? l : void 0), v = /* @__PURE__ */ i("li", {
		...h,
		"aria-label": _,
		"aria-disabled": s || void 0,
		className: e(o && "active", s && "disabled", d),
		title: g ? void 0 : m,
		children: c ? /* @__PURE__ */ i(r, { iconName: c }) : /* @__PURE__ */ i("span", { children: f })
	});
	return g ? /* @__PURE__ */ i(n, {
		content: l,
		placement: u,
		delay: {
			show: 250,
			hide: 0
		},
		className: "max-width-200",
		children: v
	}) : v;
};
//#endregion
export { a as default };

//# sourceMappingURL=PillsItem.js.map